function e(t) {
  return t.state.status === "success";
}
export {
  e as defaultShouldDehydrateQuery
};
